/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const bulkPartialPatchDependencySkipSchema = z.object({
  itemId: z.int(),
  reason: z.enum([
    'SELF_REFERENCE',
    'ALREADY_EXISTS',
    'DIRECT_CYCLE',
    'VALIDATION',
    'NOT_FOUND',
    'IMPORTED_READONLY',
  ]),
  targetItemId: z.int(),
});
